import { AppThunk } from 'src/store/store';
import {
  setRenewableLicenses,
  setRenewableLicensesFailure,
  setRenewableLicensesLoading,
  setUserLicenses,
  setUserLicensesFailure,
  setUserLicensesLoading,
} from './userLicensesSlice';
import api from 'src/api';
import { selectCurrentIDToken } from '../auth/authSelectors';

export const getUserLicensesAsync = (): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    dispatch(setUserLicensesLoading(true));
    try {
      const contToken = getState().userLicenses.userLicenses.nextContToken;
      const accessToken = selectCurrentIDToken(getState());
      const pagesLoaded =
        getState().userLicenses.userLicenses.pagesLoaded || [];
      if (!contToken && contToken !== 0) {
        dispatch(setUserLicensesLoading(false));
        return;
      }
      if (pagesLoaded.includes(contToken)) {
        dispatch(setUserLicensesLoading(false));
        return;
      }
      const data = await api.getUserLicenses(accessToken, contToken);
      const currentData = getState().userLicenses.userLicenses.data;
      dispatch(
        setUserLicenses({
          data: [...currentData, ...data.data],
          contToken,
          nextContToken: data.contToken,
          pagesLoaded: [...pagesLoaded, contToken],
        })
      );
      if (data.contToken !== null) {
        dispatch(getUserLicensesAsync());
      }
    } catch (error) {
      console.error('error loading user licenses', error);
      dispatch(
        setUserLicensesFailure(
          'Something went wrong while fetching user licneses.'
        )
      );
    }
  };
};

export const getUsersRenewableLicensesAsync = (): AppThunk<
  void,
  typeof api
> => {
  return async (dispatch, getState, api) => {
    dispatch(setRenewableLicensesLoading(true));
    try {
      const contToken = getState().userLicenses.renewableLicenses.nextContToken;
      const pagesLoaded =
        getState().userLicenses.renewableLicenses.pagesLoaded || [];
      if (!contToken && contToken !== 0) {
        dispatch(setRenewableLicensesLoading(false));
        return;
      }
      if (pagesLoaded.includes(contToken)) {
        dispatch(setRenewableLicensesLoading(false));
        return;
      }

      const accessToken = selectCurrentIDToken(getState());
      const data = await api.getUserRenewableLicenses(accessToken, contToken);
      const currentData = getState().userLicenses.renewableLicenses.data;

      dispatch(
        setRenewableLicenses({
          data: [...currentData, ...data.data],
          contToken,
          nextContToken: data.contToken,
          pagesLoaded: [...pagesLoaded, contToken],
        })
      );

      if (data.contToken !== null) {
        dispatch(getUsersRenewableLicensesAsync());
      }
    } catch (error) {
      console.error('error loading renewable licenses', error);
      dispatch(
        setRenewableLicensesFailure(
          'Something went wrong while fetching renewable licneses.'
        )
      );
    }
  };
};
